// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import Announcements from './Announcements'
import Help from './Help'
import FreshChat from './FreshChat'
import type {
  SettingsSection_organization as Organization,
} from './__generated__/SettingsSection_organization.graphql'
import type {
  SettingsSection_viewer as Viewer,
} from './__generated__/SettingsSection_viewer.graphql'

type Props = $ReadOnly<{
  viewer: Viewer,
  organization: Organization,
}>

function SettingsSection({viewer, organization}: Props): Node {
  return (
    <div className="side-bar-settings-section">
      <Announcements viewer={viewer} />
      <FreshChat organization={organization} />
      <Help organization={organization} />
    </div>
  )
}

export default (createFragmentContainer(SettingsSection, {
  organization: graphql`
    fragment SettingsSection_organization on Organization {
      ...FreshChat_organization
      ...Help_organization
    }
  `,
  viewer: graphql`
    fragment SettingsSection_viewer on Person {
      ...Announcements_viewer
    }
  `,
}): RelayFragmentContainer<typeof(SettingsSection)>)
